module.exports = __webpack_public_path__ + "static/media/no-network.4c2b800b.jpg";